import { ApolloProviderWrapper } from '@helpers'

export const withApollo = (WrappedComponent: any) => {
  return function (props: any) {
    return (
      <ApolloProviderWrapper>
        <WrappedComponent {...props} />
      </ApolloProviderWrapper>
    )
  }
}
